import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Target, Eye } from 'lucide-react';
import './AboutSection.css';

const AboutSection = () => {
  const { t } = useTranslation();
  const publicUrl = process.env.PUBLIC_URL || '';
  const aboutImage = `${publicUrl}/images/image3.jpeg`;
    const navigate = useNavigate();


  return (
    <section className="about-section section-padding" id="about">
      <div className="container">
        <div className="about-grid">
          <div className="about-image-wrapper fade-up stagger-1">
            <div className="about-image">
              <img
                src={aboutImage}
                alt={t('about_section_image_alt')}
              />
            </div>
            <div className="experience-badge">
              <div className="badge-number">{t('about_section_experience_years')}</div>
              <div className="badge-text">{t('about_section_experience_badge')}</div>
            </div>
          </div>
          <div className="about-content fade-up stagger-2">
            <div className="about-label">{t('about_section_label')}</div>
            <h2>{t('about_section_title')}</h2>
            <p>{t('about_section_description')}</p>

            <div className="mission-vision">
              <div className="mission-item">
                <div className="mission-icon">
                  <Target size={24} />
                </div>
                <h4>{t('about_section_mission_title')}</h4>
                <p>{t('about_section_mission_description')}</p>
              </div>
              <div className="vision-item">
                <div className="vision-icon">
                  <Eye size={24} />
                </div>
                <h4>{t('about_section_vision_title')}</h4>
                <p>{t('about_section_vision_description')}</p>
              </div>
            </div>

            <button className="btn btn-explore" onClick={() => navigate('/about')}>
              <span className="btn-icon">▶</span>
              {t('about_section_explore_button')}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
